import sbVerbiage from '@simplybenefits/sb-verbiage';
import i18n from '../localization/i18n.js';
const map = sbVerbiage.translations.map;

/**
 * Convert english to french for data coming from the server
 * @param type
 * @param key
 * @returns {*}
 */
function fromEnglish(type, key) {
  if (i18n.locale === "en") {
    return key;
  }
  if (map[type] && map[type].fr && map[type].fr[key]) {
    return map[type].fr[key]; // Return the French translation if available
  }

  // otherwise return whatever we can for this translation
  return key || type;
}

/**
 * Convert french to english to be sent to backend
 * @param type
 * @param key
 * @returns {*}
 */
function toEnglish(type, key) {
  if (i18n.locale === "en") {
    return key;
  }
  if (map[type] && map[type].en && map[type].en[key]) {
    return map[type].en[key]; // Return the English translation if available
  }

  // Otherwise return whatever we can for this translation
  return key || type;
}
export { fromEnglish, toEnglish };